/**
 * Compound presets — population-average pharmacokinetic parameters.
 *
 * Values are tunable; all are estimates and should be refined with
 * blood-test calibration in a future release. Sources cited in
 * plans/halvn-mvp.md.
 */

import type { CompoundParams } from './engine';

export type CompoundKind = 'ester' | 'glp1' | 'custom';

export type CompoundPreset = CompoundParams & {
  id: string;
  kind: CompoundKind;
  name: string;
  shortCode: string;
  defaultUnit: 'mg' | 'mcg';
};

export const COMPOUND_PRESETS: readonly CompoundPreset[] = [
  {
    id: 'test-e',
    kind: 'ester',
    name: 'Testosterone Enanthate',
    shortCode: 'Test E',
    absorptionHalfLifeHours: 108,
    eliminationHalfLifeHours: 1.5,
    bioavailability: 1.0,
    defaultUnit: 'mg',
  },
  {
    id: 'test-c',
    kind: 'ester',
    name: 'Testosterone Cypionate',
    shortCode: 'Test C',
    absorptionHalfLifeHours: 192,
    eliminationHalfLifeHours: 1.5,
    bioavailability: 1.0,
    defaultUnit: 'mg',
  },
  {
    id: 'test-p',
    kind: 'ester',
    name: 'Testosterone Propionate',
    shortCode: 'Test P',
    absorptionHalfLifeHours: 19,
    eliminationHalfLifeHours: 1.5,
    bioavailability: 1.0,
    defaultUnit: 'mg',
  },
  {
    id: 'tirzepatide',
    kind: 'glp1',
    name: 'Tirzepatide',
    shortCode: 'Tirz',
    absorptionHalfLifeHours: 120,
    eliminationHalfLifeHours: 36,
    bioavailability: 0.8,
    defaultUnit: 'mg',
  },
  {
    id: 'semaglutide',
    kind: 'glp1',
    name: 'Semaglutide',
    shortCode: 'Sema',
    absorptionHalfLifeHours: 168,
    eliminationHalfLifeHours: 36,
    bioavailability: 0.89,
    defaultUnit: 'mg',
  },
  {
    id: 'retatrutide',
    kind: 'glp1',
    name: 'Retatrutide',
    shortCode: 'Reta',
    absorptionHalfLifeHours: 156,
    eliminationHalfLifeHours: 30,
    bioavailability: 0.8,
    defaultUnit: 'mg',
  },
];

export function findPreset(id: string): CompoundPreset | undefined {
  return COMPOUND_PRESETS.find((p) => p.id === id);
}
